import { BASE_URL, VENDOR_ASSESSMENT_DEFINITION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { IAssessmentLevels } from "models/assessmentLevels";

export async function getAssessmentLevels(params: string = "") : Promise<IAssessmentLevels[]> {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + params);
  return response.data;
}